<template>
    <div class="play-list">
        <ul class="week-list">
            <li v-for="(week, weekIndex) in weekList" :key="week.id" class="week-item">
                <div class="week-item-title" @click="toggleList(week, weekIndex)">
                    <div class="week-item-title-content">
                        <span class="week-item-title-text">{{week.name}}</span>
                        <span class="week-item-title-time">{{ week.extraInfo }}</span>
                    </div>
                    <img src="../images/chevron-top.png" class="week-item-title-icon" :class="{ 'is-rotated': week.isExpanded }">
                </div>
                <transition name="slide">
                    <ul v-if="week.isExpanded && week.audios.length" class="song-list">
                        <li
                            v-for="(audio) in week.audios" 
                            :key="audio.id" 
                            class="song-item" 
                            :class="{ 'is-playing': audio.playing }"
                            @click="handlePlay(audio)">
                            <div class="song-item-content">
                                <div class="song-item-content-footer">
                                    <span class="name">{{audio.name}}</span>
                                </div>
                            </div>
                            <img
                                v-show="!audio.playing"
                                src="../images/list-play.png"
                                class="song-item-icon"
                            >
                            <img
                                v-show="audio.playing"
                                src="../images/list-pause.png"
                                class="song-item-icon"
                            >
                            <div class="menu-item-num">
                                <span class="menu-item-num-text">{{audio.num || 0}}</span>
                                已听
                            </div>
                        </li>
                    </ul>
                </transition>
            </li>
        </ul>
    </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
    name: 'PlayerList',
    props: {
        weekList: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            dayjs,
            playList: [],
            currentSong: {},
        }
    },
    watch: {
        weekList(val) {
            this.playList = val.map(item => ({
                ...item,
                audios: item.audios.map(audio => ({
                    ...audio,
                    playing: false,
                })),
                isExpanded: false,
            }))
        }
    },
    methods: {
        toggleList(week) {
            week.isExpanded = !week.isExpanded
        },
        handlePlay(audio) {
            audio.playing = !audio.playing
            
            this.$emit('play', audio)
        }
    }
}
</script>

<style lang="stylus" scoped>
.play-list {
    width: 700px;
    padding: 100px 0;
    background: url('../images/list-bg.png') center/100% 100% no-repeat;
}

.week-list {
    width: 580px;
    height: 100%;
    padding: 0;
    margin: 0 auto;
    overflow: auto;
    list-style: none;
}
.week-item {
    margin-bottom: 16px;
}
.week-item-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    border: 6px solid #a4d3ff;
    border-radius: 22px;
    box-shadow: 0px 2px 3px 0px rgba(13,22,73,0.33); 
    background-color: #fff;
}
.week-item-title-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
}
.week-item-title-text {
    font-size: 34px;
    line-height: 1;
    color: #434343;
    text-align: left;
}
.week-item-title-time {
    font-size: 24px;
    color: #4589C7;
}
.week-item-title-icon {
    width: 42px;
    height: 24px;
    transition: transform 0.3s ease;


    &.is-rotated {
        transform: rotate(180deg);
    }
}

.song-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 0;
    margin: 8px auto;
    list-style: none;
}
.song-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 480px;
    padding: 10px 20px;
    background: rgba(44,23,82,0.30);
    border-radius: 22px;
    box-shadow: 0px -1px 0px 0px rgba(73,201,255,0.48) inset, 0px 0px 7.76px 0.24px rgba(10,0,88,0.25) inset; 
    color: #fff;

    &.is-playing {
        width: 520px;
        background: linear-gradient(0deg,#cdfa6e 0%, #8bf173 99%);
        border-radius: 22px;
        box-shadow: 0px 2px 3px 0px rgba(13,29,73,0.11), 0px 1px 3px 0px rgba(228,255,164,0.25) inset, 0px -1px 3px 0px rgba(2,86,67,0.83) inset, 0px 0px 2.91px 0.09px rgba(255,255,255,0.25) inset; 
        
        .name {
            color: #377B0A;
        }
    }
}
.song-item-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
    margin-right: 40px;
}
.song-item-text {
    font-size: 20px;
}
.song-item-content-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    color: #AECEDD;
    font-size: 28px;
    text-align: left;
}
.song-item-icon {
    width: 48px;
    height: 48px;
}

.menu-item-num {
    display: flex;
    align-items: center;
    margin-left: 12px;
    flex-direction: column;
    font-size: 20px;
    color: #fff;
}
.menu-item-num-text {
    font-size: 24px;
    font-weight: bold;
}
.white {
    color: #fff;
}

/* 动画基础样式 */
.slide-enter-active, .slide-leave-active {
    transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to {
    opacity: 0;
}
</style>